import React, { useState } from 'react';
import './TimetableMaker.css';

// --- MASTER SLOT DATA (Unchanged) ---
const MASTER_SLOTS = {
  // Monday
  'A11': { day: 'MON', time: '08:30-10:00' }, 'B11': { day: 'MON', time: '10:05-11:35' }, 'C11': { day: 'MON', time: '11:40-13:10' }, 'A21': { day: 'MON', time: '13:15-14:45' }, 'A14': { day: 'MON', time: '14:50-16:20' }, 'B21': { day: 'MON', time: '16:25-17:55' }, 'C21': { day: 'MON', time: '18:00-18:30' },
  // Tuesday
  'D11': { day: 'TUE', time: '08:30-10:00' }, 'E11': { day: 'TUE', time: '10:05-11:35' }, 'F11': { day: 'TUE', time: '11:40-13:10' }, 'D21': { day: 'TUE', time: '13:15-14:45' }, 'E14': { day: 'TUE', time: '14:50-16:20' }, 'E21': { day: 'TUE', time: '16:25-17:55' }, 'F21': { day: 'TUE', time: '18:00-18:30' },
  // Wednesday
  'A12': { day: 'WED', time: '08:30-10:00' }, 'B12': { day: 'WED', time: '10:05-11:35' }, 'C12': { day: 'WED', time: '11:40-13:10' }, 'A22': { day: 'WED', time: '13:15-14:45' }, 'B14': { day: 'WED', time: '14:50-16:20' }, 'B22': { day: 'WED', time: '16:25-17:55' }, 'A24': { day: 'WED', time: '18:00-18:30' },
  // Thursday
  'D12': { day: 'THU', time: '08:30-10:00' }, 'E12': { day: 'THU', time: '10:05-11:35' }, 'F12': { day: 'THU', time: '11:40-13:10' }, 'D22': { day: 'THU', time: '13:15-14:45' }, 'F14': { day: 'THU', time: '14:50-16:20' }, 'E22': { day: 'THU', time: '16:25-17:55' }, 'F22': { day: 'THU', time: '18:00-18:30' },
  // Friday
  'A13': { day: 'FRI', time: '08:30-10:00' }, 'B13': { day: 'FRI', time: '10:05-11:35' }, 'C13': { day: 'FRI', time: '11:40-13:10' }, 'A23': { day: 'FRI', time: '13:15-14:45' }, 'C14': { day: 'FRI', time: '14:50-16:20' }, 'B23': { day: 'FRI', time: '16:25-17:55' }, 'B24': { day: 'FRI', time: '18:00-18:30' },
  // Saturday
  'D13': { day: 'SAT', time: '08:30-10:00' }, 'E13': { day: 'SAT', time: '10:05-11:35' }, 'F13': { day: 'SAT', time: '11:40-13:10' }, 'D23': { day: 'SAT', time: '13:15-14:45' }, 'D14': { day: 'SAT', time: '14:50-16:20' }, 'D24': { day: 'SAT', time: '16:25-17:55' }, 'E23': { day: 'SAT', time: '18:00-18:30' },
  // Example Lab Slots (add more as needed)
  'L1+L2': { day: 'MON', time: '08:30-10:00' },
  'L3+L4': { day: 'TUE', time: '10:05-11:35' },
};
// ------------------------

// --- Grid Structure (Unchanged) ---
const DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
const TIMES = ['08:30-10:00', '10:05-11:35', '11:40-13:10', 'Lunch', '13:15-14:45', '14:50-16:20', '16:25-17:55', '18:00-18:30'];
const SLOT_GRID = {
  'MON-08:30-10:00': 'A11', 'MON-10:05-11:35': 'B11', 'MON-11:40-13:10': 'C11', 'MON-13:15-14:45': 'A21', 'MON-14:50-16:20': 'A14', 'MON-16:25-17:55': 'B21', 'MON-18:00-18:30': 'C21',
  'TUE-08:30-10:00': 'D11', 'TUE-10:05-11:35': 'E11', 'TUE-11:40-13:10': 'F11', 'TUE-13:15-14:45': 'D21', 'TUE-14:50-16:20': 'E14', 'TUE-16:25-17:55': 'E21', 'TUE-18:00-18:30': 'F21',
  'WED-08:30-10:00': 'A12', 'WED-10:05-11:35': 'B12', 'WED-11:40-13:10': 'C12', 'WED-13:15-14:45': 'A22', 'WED-14:50-16:20': 'B14', 'WED-16:25-17:55': 'B22', 'WED-18:00-18:30': 'A24',
  'THU-08:30-10:00': 'D12', 'THU-10:05-11:35': 'E12', 'THU-11:40-13:10': 'F12', 'THU-13:15-14:45': 'D22', 'THU-14:50-16:20': 'F14', 'THU-16:25-17:55': 'E22', 'THU-18:00-18:30': 'F22',
  'FRI-08:30-10:00': 'A13', 'FRI-10:05-11:35': 'B13', 'FRI-11:40-13:10': 'C13', 'FRI-13:15-14:45': 'A23', 'FRI-14:50-16:20': 'C14', 'FRI-16:25-17:55': 'B23', 'FRI-18:00-18:30': 'B24',
  'SAT-08:30-10:00': 'D13', 'SAT-10:05-11:35': 'E13', 'SAT-11:40-13:10': 'F13', 'SAT-13:15-14:45': 'D23', 'SAT-14:50-16:20': 'D14', 'SAT-16:25-17:55': 'D24', 'SAT-18:00-18:30': 'E23',
};
// ----------------------

// --- Color Palette (Unchanged) ---
const COLOR_PALETTE = [
  { bg: '#ffebee', text: '#b71c1c', border: '#e57373' }, // Red
  { bg: '#e8eaf6', text: '#283593', border: '#7986cb' }, // Indigo
  { bg: '#e0f2f1', text: '#00695c', border: '#4db6ac' }, // Teal
  { bg: '#fff3e0', text: '#e65100', border: '#ffb74d' }, // Orange
  { bg: '#f3e5f5', text: '#6a1b9a', border: '#ba68c8' }, // Purple
  { bg: '#e1f5fe', text: '#0277bd', border: '#4fc3f7' }, // Light Blue
  { bg: '#f0f4c3', text: '#827717', border: '#d4e157' }, // Lime
  { bg: '#fbe9e7', text: '#d84315', border: '#ff8a65' }, // Deep Orange
];
// ---------------------------------

const TimetableMaker = () => {
  const [courses, setCourses] = useState([]);
  // Form State
  const [currentCourse, setCurrentCourse] = useState('');
  const [currentFaculty, setCurrentFaculty] = useState('');
  const [currentVenue, setCurrentVenue] = useState('');
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [searchTerm, setSearchTerm] = useState(''); // 1. ADD NEW STATE FOR SEARCH

  // Grid and Color State
  const [gridState, setGridState] = useState({});
  const [courseColors, setCourseColors] = useState({});

  // Checkbox Handler (Unchanged)
  const handleSlotSelection = (e) => {
    const slotName = e.target.value;
    if (e.target.checked) {
      setSelectedSlots([...selectedSlots, slotName]);
    } else {
      setSelectedSlots(selectedSlots.filter(s => s !== slotName));
    }
  };

  // Add Course Handler (Unchanged)
  const handleAddCourse = (e) => {
    e.preventDefault();
    const courseName = currentCourse.trim();
    if (!courseName) {
      alert('Please enter a course name.');
      return;
    }
    if (selectedSlots.length === 0) {
      alert('Please select at least one slot.');
      return;
    }

    const clashes = [];
    for (const slotName of selectedSlots) {
      const slotInfo = MASTER_SLOTS[slotName];
      const cellId = `${slotInfo.day}-${slotInfo.time}`;
      if (gridState[cellId]) {
        clashes.push({ slot: slotName, course: gridState[cellId].course });
      }
    }

    if (clashes.length > 0) {
      const clashMsg = clashes.map(c => `${c.slot} conflicts with ${c.course}`).join('\n');
      alert(`Clash detected!\n${clashMsg}`);
      return;
    }

    let colorSet = courseColors[courseName.toLowerCase()];
    if (!colorSet) {
      const newColorIndex = Object.keys(courseColors).length % COLOR_PALETTE.length;
      colorSet = COLOR_PALETTE[newColorIndex];
      setCourseColors({ ...courseColors, [courseName.toLowerCase()]: colorSet });
    }

    const newGridState = { ...gridState };
    const newCourse = {
      id: Date.now(),
      name: courseName,
      faculty: currentFaculty.trim(),
      venue: currentVenue.trim(),
      slots: selectedSlots,
      colorSet: colorSet
    };

    for (const slotName of selectedSlots) {
      const slotInfo = MASTER_SLOTS[slotName];
      const cellId = `${slotInfo.day}-${slotInfo.time}`;
      newGridState[cellId] = {
        course: newCourse.name,
        faculty: newCourse.faculty,
        venue: newCourse.venue,
        slot: slotName,
        colorSet: newCourse.colorSet
      };
    }

    setGridState(newGridState);
    setCourses([...courses, newCourse]);

    setCurrentCourse('');
    setCurrentFaculty('');
    setCurrentVenue('');
    setSelectedSlots([]);
    setSearchTerm(''); // Clear search term on success
  };

  // Remove Course Handler (Unchanged)
  const handleRemoveCourse = (courseToRemove) => {
    setCourses(courses.filter(c => c.id !== courseToRemove.id));
    
    const newGridState = { ...gridState };
    for (const slotName of courseToRemove.slots) { 
      const slotInfo = MASTER_SLOTS[slotName];
      if (slotInfo) {
        const cellId = `${slotInfo.day}-${slotInfo.time}`;
        delete newGridState[cellId];
      }
    }
    setGridState(newGridState);
  };

  // --- 2. NEW: FILTER LOGIC ---
  const filteredSlots = Object.keys(MASTER_SLOTS).filter(slot => {
    const slotInfo = MASTER_SLOTS[slot];
    const search = searchTerm.toLowerCase();

    return (
      slot.toLowerCase().includes(search) ||         // "A11"
      slotInfo.day.toLowerCase().includes(search) || // "MON"
      slotInfo.time.includes(search)                 // "08:30"
    );
  });
  // -----------------------------

  return (
    <div className="timetable-container">
      {/* --- Column 1: Form & Course List --- */}
      <div className="timetable-sidebar">
        <div className="timetable-card">
          <h4>Add a Course</h4>
          <form className="timetable-form" onSubmit={handleAddCourse}>
            {/* ... (Course, Faculty, Venue inputs - No changes) ... */}
            <div className="form-group">
              <label>Course Name / Code</label>
              <input type="text" placeholder="e.g., CSE4001" value={currentCourse} onChange={(e) => setCurrentCourse(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Faculty (Optional)</label>
              <input type="text" placeholder="e.g.,  NAWAB M.O. " value={currentFaculty} onChange={(e) => setCurrentFaculty(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Venue (Optional)</label>
              <input type="text" placeholder="e.g., AB1-404" value={currentVenue} onChange={(e) => setCurrentVenue(e.target.value)} />
            </div>
            
            {/* --- 3. UPDATED JSX FOR SLOTS --- */}
            <div className="form-group">
              <label>Slots (Select all that apply)</label>
              {/* --- ADD THIS SEARCH INPUT --- */}
              <input
                type="text"
                placeholder="Search slots by code, day, or time..."
                className="slot-search-input" 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {/* --- END OF SEARCH INPUT --- */}

              <div className="slot-selection-list">
                {/* --- 4. MAP OVER `filteredSlots` INSTEAD OF `MASTER_SLOTS` --- */}
                {filteredSlots.length > 0 ? (
                  filteredSlots.map(slot => (
                    <label key={slot} className="slot-checkbox-item">
                      <input
                        type="checkbox"
                        value={slot}
                        checked={selectedSlots.includes(slot)} 
                        onChange={handleSlotSelection}
                      />
                      {slot} ({MASTER_SLOTS[slot].day} @ {MASTER_SLOTS[slot].time})
                    </label>
                  ))
                ) : (
                  <span className="no-slots-found">No slots found matching "{searchTerm}"</span>
                )}
              </div>
            </div>
            {/* --- End Checkbox List --- */}

            <button type="submit" className="btn-add-course">
              + Add to Timetable
            </button>
          </form>
        </div>

        {/* ... (Rest of the file is unchanged: "Your Courses" card and the grid) ... */}
        <div className="timetable-card">
          <h4>Your Courses</h4>
          <div className="course-list">
            {courses.length === 0 ? (
              <p className="empty-list-text">Your added courses will appear here.</p>
            ) : (
              courses.map(course => (
                <div 
                  className="course-list-item" 
                  key={course.id} 
                  style={{ borderLeft: `5px solid ${course.colorSet.border}` }}
                >
                  <div className="course-item-info">
                    <strong>{course.name}</strong>
                    <span>{course.slots.join(', ')} {course.faculty && `| ${course.faculty}`}</span>
                  </div>
                  <button 
                    className="btn-remove-course"
                    onClick={() => handleRemoveCourse(course)}
                  >
                    &times;
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/* --- Column 2: The Timetable Grid (No JSX changes needed here) --- */}
      <div className="timetable-grid-container">
        <table className="timetable-grid">
          <thead>
            <tr>
              <th>THEORY</th>
              <th>Start</th>
              {TIMES.map(time => (
                time === 'Lunch' ? <th key={time} rowSpan="2" className="lunch-cell">Lunch</th> : <th key={time}>{time.split('-')[0]}</th>
              ))}
            </tr>
            <tr>
              <th></th>
              <th>End</th>
              {TIMES.map(time => (
                time === 'Lunch' ? null : <th key={time}>{time.split('-')[1]}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {DAYS.map(day => (
              <tr key={day}>
                <td className="day-cell">{day}</td>
                <td className="theory-cell">THEORY</td>
                
                {TIMES.map(time => {
                  if (time === 'Lunch') {
                    return <td key={time} className="lunch-cell">Lunch</td>;
                  }
                  
                  const cellId = `${day}-${time}`;
                  const cellData = gridState[cellId];
                  const theorySlot = SLOT_GRID[cellId];
                  
                  return (
                    <td 
                      key={cellId} 
                      className="grid-cell"
                      style={cellData ? { 
                        backgroundColor: cellData.colorSet.bg,
                        borderColor: cellData.colorSet.border,
                        color: cellData.colorSet.text
                      } : {}}
                    >
                      {cellData ? (
                        <div className="filled-cell-content">
                          <strong>{cellData.course} ({cellData.slot})</strong>
                          {cellData.faculty && <span className="cell-details">{cellData.faculty}</span>}
                          {cellData.venue && <span className="cell-details">{cellData.venue}</span>}
                        </div>
                      ) : (
                        <span className="slot-code">{theorySlot}</span>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TimetableMaker;